import { AxiosResponse } from 'axios';
import { HttpResponse } from 'shell/models/http-response';
import { CertificateForm } from '../form';
import { DateTime } from 'luxon';
import { HistoricalReleasedService } from 'shell/models/historical-released-services';

export const transformCertificateHistorical = (
  httpResponse: AxiosResponse<HttpResponse<HistoricalReleasedService>>
): CertificateForm => {
  const data = httpResponse.data.payload || {};

  const descriptionState = httpResponse.data.payload?.statoServizio;

  //   let act = '';
  //   if (data.numeroCartaIdentita) {
  //     act = data?.numeroCartaIdentita || '';
  //   }

  const response: CertificateForm = {
    //TODO
    acronym: data.tipoRegistro || '',
    year: data.annoServizio || '',
    progressive: data.numeroProgressivo?.toString() || '',
    dateForm: data.dataRilascio ? DateTime.fromISO(data.dataRilascio) : null,
    description: data.descrizioneServizio,
    // documentType: data?.ti,
    holderFiscalCode: data.codiceFiscaleIntestatario || '',
    applicantFiscalCode: data.codiceFiscaleRichiedente || '',
    releaseMode: data.modalitaRilascio
      ? { id: data.modalitaRilascio, value: data.modalitaRilascio }
      : null,
    holderDateOfBirth: data.dataNascita ? DateTime.fromISO(data.dataNascita) : undefined,
    holderName: data.intestatario,
    holderPlaceOfBirth: data.luogoNascita,
    // applicantDateOfBirth: data.richiedente?.dataNascita
    //   ? DateTime.fromISO(data.richiedente.dataNascita)
    //   : undefined,
    applicantName: data.richiedente,
    // applicantPlaceOfBirth: data.richiedente?.descrizioneLuogoNascita,
    payment: data.modalitaPagamento || '',
    state: descriptionState,
    // act: isActVisibile ? act : '',
    stamp: data.importoBollo || '0.00',
    secretary: data.importoDirittiSegreteria || '0.00',
    civilStatus: data.importoDirittiStatoCivile || '0.00',
    fixed: data.importoDirittiFissi || '0.00',
    refund: data.importoSpese || '0.00',
    emitted: data.nomeOperatore || '',
    service: data.numeroServizio?.toString() || '',
    date: data.dataRilascio ? DateTime.fromISO(data.dataRilascio) : null, // TODO
    time: data.oraRilascio ? DateTime.fromISO(data.oraRilascio) : null, // TODO
    justification: data.operatoreAnnullamento || 'E',
    // void: data.codiceStato === '3' || data.codiceStato === '4' ? true : false,
    dateVoid: data.dataAnnullamento ? DateTime.fromISO(data.dataAnnullamento) : null,
    voidBy: data.operatoreAnnullamento || '',
    // birthDate: data.timestampRilascio ? DateTime.fromISO(data.timestampRilascio) : null, // TODO
    // certifications: (data.tipoCertificatiContestuali || []).map((certification) => ({
    //   key: certification.key?.codiceDocumento || '',
    //   label: certification.descrizioneTipoDocumento || '',
    // })),
    documentCode: data?.codiceServizio || '',
    // applicantReleaseReason: data?.richiedente?.motivoRilascio || '',
    serviceVoidReason: '',
  };

  return response;
};
